<!-- 编辑 -->
<template>
  <div class="box">
    <!-- 路径 -->
    <div class="path">
      <img class="path_img" src="../../../../../assets/images/path.png"/>
      <div class="path_txt">运营管理系统 > 合作伙伴 > 运营投放 > 详情</div>
    </div>
    <!-- 编辑 -->
    <div class="work">
      <!--表单提交-->
      <el-form class="work_form" :model="formData" ref="formData" label-position="right" label-width="200px">
        <el-form-item label="应用：" prop="app_id">
          <el-tag>{{formData.app_name}}</el-tag>
        </el-form-item>
        <el-form-item label="应用类型：" prop="app_type" v-if="formData.app_id && apps && apps.find(item => item.app_id==formData.app_id).business_line == 'quickapp'">
          <el-tag>{{appTypes[formData.app_type]}}</el-tag>
        </el-form-item>
        <el-form-item label="渠道：" prop="channel_id">
          <el-tag>({{formData.channel_id}}){{formData.channel_name}}</el-tag>
        </el-form-item>
        <el-form-item label="渠道号：" prop="channel_slot_id">
          <el-tag>{{formData.channel_slot_id}}</el-tag>
        </el-form-item>
        <el-form-item label="投放内容：" prop="measure_id,book_id,shortplay_id" v-if="formData.app_id && apps && apps.find(item => item.app_id==formData.app_id).business_line == 'quickapp'">
          <el-tag>
            {{formData.book_id ? '[小说]' + books.find(item => item.book_id == formData.book_id).book_name : ''}}
            {{formData.measure_id ? '[测评]' + appraises.find(item => item.appraise_id == formData.measure_id).appraise_title : ''}}
            {{formData.shortplay_id && !(formData.app_id==30 && formData.app_type==62) ? '[短剧]' + shortplays.find(item => item.shortplay_id == formData.shortplay_id).shortplay_name : ''}}
            {{formData.shortplay_id && formData.app_id==30 && formData.app_type==62 ? '[短剧]' + vshortplays.find(item => item.shortplay_id == formData.shortplay_id).shortplay_name : ''}}
            {{formData.cookbook_id ? '[菜谱]' + cookbooks[formData.cookbook_id] : ''}}
            {{formData.health_class_id!=undefined ? '[养生分类]' + health_classes[formData.health_class_id] : ''}}
            {{formData.health_id ? '[养生]' + healthes[formData.health_id] : ''}}
          </el-tag>
        </el-form-item>
        <el-form-item label="投放平台：" prop="issue_platform">
          <el-tag>
            {{formData.issue_platform && issuePlatforms && issuePlatforms.find(item => item.issue_platform_tag==formData.issue_platform).issue_platform_name}}
          </el-tag>
        </el-form-item>
        <el-form-item label="投放流量：" prop="issue_flow">
          <el-tag>
            {{formData.issue_flow && issueFlows && issueFlows.find(item => item.issue_flow_tag==formData.issue_flow).issue_flow_name}}
          </el-tag>
        </el-form-item>
        <el-form-item label="投放账号：" prop="issue_account" v-if="formData.issue_platform=='oppo' || formData.issue_platform=='vivo' || formData.issue_platform=='huawei' || formData.issue_platform=='toutiao' || formData.issue_platform=='kuaishou' || formData.issue_platform=='qtt' || formData.issue_platform=='gdt' || formData.issue_platform=='uc' || formData.issue_platform=='wifi'">
          <el-tag>{{formData.issue_account}}</el-tag>
        </el-form-item>
        <el-form-item label="投放账号KEY：" prop="issue_account_key" v-if="formData.issue_platform=='huawei' || formData.issue_platform=='wifi'">
          <el-tag>{{formData.issue_account_key}}</el-tag>
        </el-form-item>
        <el-form-item label="百度账号ID：" prop="issue_account" v-if="formData.issue_platform=='baidu'">
          <el-tag>{{formData.issue_account}}</el-tag>
        </el-form-item>
        <el-form-item label="百度账号名称：" prop="issue_account_name" v-if="formData.issue_platform=='baidu'">
          <el-tag>{{formData.issue_account_name}}</el-tag>
        </el-form-item>
        <el-form-item label="OPPO API-ID：" prop="oppo_api_id" v-if="formData.issue_platform=='oppo'">
          <el-tag>{{formData.oppo_api_id}}</el-tag>
        </el-form-item>
        <el-form-item label="OPPO API-KEY：" prop="oppo_api_key" v-if="formData.issue_platform=='oppo'">
          <el-tag>{{formData.oppo_api_key}}</el-tag>
        </el-form-item>
        <el-form-item label="百度 aKey：" prop="baidu_api_akey" v-if="formData.issue_platform=='baidu'">
          <el-tag>{{formData.baidu_api_akey}}</el-tag>
        </el-form-item>
        <el-form-item label="VIVO 数据源：" prop="vivo_api_ds" v-if="formData.issue_platform=='vivo'">
          <el-tag>{{formData.vivo_api_ds}}</el-tag>
        </el-form-item>
        <el-form-item label="回传类型：" prop="issue_effect_type" v-if="issueEffects && issueEffects.length >= 1">
          <el-tag>{{issueEffects.find(item=>item.issue_platform_tag==formData.issue_platform && item.issue_effect_tag==formData.issue_effect_type) ? issueEffects.find(item=>item.issue_platform_tag==formData.issue_platform && item.issue_effect_tag==formData.issue_effect_type).issue_effect_name : ''}}</el-tag>
        </el-form-item>
        <el-form-item label="投放H5链接：" prop="issue_h5_url">
          <el-input 
            type="textarea" 
            :rows="2"
            size="large"
            autosize 
            clearable 
            readonly
            v-model="formData.issue_h5_url">
          </el-input>
        </el-form-item>
        <el-form-item label="投放Hap链接：" prop="issue_hap_url" v-if="formData.app_id && apps && apps.find(item => item.app_id==formData.app_id).business_line == 'quickapp'">
          <el-input 
            type="textarea" 
            :rows="2"
            size="large"
            autosize 
            clearable 
            readonly
            v-model="formData.issue_hap_url">
          </el-input>
        </el-form-item>
        <el-form-item label="投放点击监测链接：" prop="issue_tc_url">
          <el-input 
            type="textarea" 
            :rows="2"
            size="large"
            autosize 
            clearable 
            readonly
            v-model="formData.issue_tc_url">
          </el-input>
        </el-form-item>
        
        <el-form-item label="审核状态：" prop="approve_status" required>
          <el-tag width="60" type="primary" v-if="formData.approve_status==0">{{approveStatusMap[formData.approve_status]}}</el-tag>
          <el-tag width="60" type="danger" v-else-if="formData.approve_status==1">{{approveStatusMap[formData.approve_status]}}</el-tag>
          <el-tag width="60" type="success" v-else-if="formData.approve_status==2">{{approveStatusMap[formData.approve_status]}}</el-tag>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" class="btn_cancel" @click="onCancel">返回</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      // 操作员对象
      operator: null,

      // 应用对象数据
      formData: { 
        app_id: null,
        app_name: null,
        app_type: null,
        issue_platform: null,
        issue_flow: null,
        channel_id: null,
        channel_slot_id: null,
        measure_id: null,
        measure_title: null,
        book_id: null,
        book_name: null,
        shortplay_id: null,
        shortplay_name: null,
        issue_account: null,
        issue_account_name: null,
        issue_account_key: null,
        oppo_api_id: null,
        oppo_api_key: null,
        vivo_api_ds: null,
        baidu_api_akey: null,
        issue_effect_type: null,
        issue_cfg_scene: null,
        issue_ad_scene: null,
        issue_ad_bidbase: null,
        issue_h5_url: null,
        issue_hap_url: null,
        issue_tc_url: null,
        issue_time: null,
        approve_status: null,
      },
      
      apps: null,             //应用
      channels: null,         //渠道列表
      channelSlots: null,     //渠道位置

      appraises: null,        //测评列表
      books: null,            //小说
      shortplays: null,       //短剧
      vshortplays: null,      //vivo 短剧

      // 投放平台、流量、效果列表
      issuePlatforms: null,
      issueFlows: null,
      issueEffects: null,

      // 应用类型
      appTypes: {
        5:  "H5",
        61: "OPPO",
        62: "VIVO",
        63: "小米",
        65: "华为",
      },

      // 菜谱
      cookbooks: {
        1:    '红烧肉',
        2:	  '排骨玉米汤',
        3:	  '鱼香肉丝',
        4:	  '炸酱面',
        5:	  '糖醋排骨',
        6:	  '可乐鸡翅',
        7:	  '红焖羊排萝卜',
        8:	  '木须肉',
        9:	  '酸辣土豆丝',
        10:	  '芒果圆子西米露',
        11:   '白菜豆腐煲',
        12:	  '油闷大虾',
        13:	  '煎蛋白菜豆腐汤',
        14:	  '照烧肥牛饭',
        15:   '东北锅包肉',
        16:   '家庭版葡式蛋挞',
        17:	  '秋葵',
        18:	  '三鲜饺子',
        19:	  '咖喱鸡肉饭',
        20:	  '酸辣汤',
        99999:'转盘'
      },

      // 健康养生
      healthes: {
        1:    '警惕亚健康，守护生命活力',
        2:	  '如何呵护颈椎健康',
        3:	  '如何远离腰椎问题',
        4:	  '关注 “工作病”，守护职场健康',
        5:	  '女性经期养生指南',
        6:	  '孕期养生指南',
        7:	  '老年人如何吃才健康？',
        8:	  '老年常见疾病如何预防？',
        9:	  '运动，让老人更健康的秘诀',
        10:	  '老年人觉少正常吗？',
        11:   '解压木鱼真的解压吗',
        12:	  '音乐如何助眠',
        13:	  '摆脱睡眠困扰',
        14:	  '冥想的妙用',
        15:   '冥想，减压神器',
        16:   '音乐，让睡眠更轻松',
        17:	  '常见食材的养生功效',
        18:	  '慢食文化与健康',
        19:	  '胶原蛋白的秘密',
        20:	  '食物搭配禁忌表',
        21:   '暖冬滋补秘籍',
        22:   '顺应节气，吃出健康',
        23:   '如何健康瘦？',
        24:   '八段锦古法养生',
        25:   '上班族如何保持日常运动',
        26:   '日常运动养生小技巧',
        27:   '瑜伽的好处',
        28:   '传统健身的养生智慧',
        29:   '选择合适的户外运动',
        30:   '科学健身',
      },
      
      health_classes: {
        0:    '食材养生',
        1:	  '冥想疗愈',
        2:	  '运动养生',
        3:	  '养生人群',
      },

      // 广告资源位打底广告场景
      adResourceBidbases: {
        1: '打底场景 1',
        2: '打底场景 2',
        3: '打底场景 3',
        4: '打底场景 4',
        5: '打底场景 5',
      },

      // 广告场景
      issueAdScenes: {
        1: '广告场景 1',
        2: '广告场景 2',
        3: '广告场景 3',
        4: '广告场景 4',
        5: '广告场景 5',
      },

      // 应用配置场景
      issueCfgScenes: {
        1: '配置场景1',
        2: '配置场景2',
        3: '配置场景3',
        4: '配置场景4',
        5: '配置场景5',
      },
      
      // 状态
      issueStatusMap: {
        1: "有效",
        0: "无效"
      },

      // 审核状态
      approveStatusMap: {
        0:  "待审核",
        1:  "审核不通过",
        2:  "审核通过"
      },
    };
  },
  
  async created() {
    // 加载原对象
    if(this.$route.params.app_issue_id) {
        this.formData = this.$route.params;
    }
    // 从缓存中恢复操作员对象
    let operatorSerial = localStorage.getItem('operator');
    if(operatorSerial==null || operatorSerial==undefined || operatorSerial=='') {
      // 返回登录页面
      this.$router.push('/');
      return;
    }
    this.operator = JSON.parse(operatorSerial);
    // 初始化数据
    await this.initApps();
    await this.initIssuePlatforms();
    await this.loadIssueFlows();
    await this.loadIssueEffects();
    await this.initAppraises();
    await this.initBooks();
    await this.initShortplays();
  },
  
  methods: {
    // 初始化应用
    async initApps(){
      // 清空当前集合数据
      this.apps = null;
      // 调用接口
      let res = await this.$api.apiPartnerCommonApps({
        operatorId: this.operator.operatorId
      });
      // 应用数据存进data
      this.apps = res.content;
    },

    // 初始化发布平台
    async initIssuePlatforms() {
      // 清空当前投放平台
      this.issuePlatforms = null;
      // 调用接口
      let res = await this.$api.apiCommonIssuePlatforms();
      // 保存结果
      this.issuePlatforms = res.content;
    },

    // 加载发布平台流量类型
    async loadIssueFlows() {
      // 清空当前流量类型
      this.issueFlows = null;
      // 调用接口
      let res = await this.$api.apiCommonIssueFlows({issuePlatformTag: this.formData.issue_platform});
      // 保存结果
      this.issueFlows = res.content;
    },

    // 加载发布平台效果类型
    async loadIssueEffects() {
      // 清空当前效果
      this.issueEffects = null;
      // 调用接口
      let res = await this.$api.apiCommonIssueEffects({issuePlatformTag: this.formData.issue_platform});
      // 保存结果
      this.issueEffects = res.content;
    },

    // 初始化测评(新)
    async initAppraises() {
      // 清空当前测评
      this.appraises = null;
      // 调用接口
      let res = await this.$api.apiCommonAppraises();
      // 保存结果
      this.appraises = res.content;
    },

    // 初始化小说
    async initBooks() {
      // 清空当前测评
      this.books = null;
      // 调用接口
      let res = await this.$api.apiCommonBooks();
      // 保存结果
      this.books = res.content;
    },

    // 初始化短剧
    async initShortplays() {
      // 加载短剧
      this.shortplays = null;
      let res = await this.$api.apiCommonShortplays();
      this.shortplays = res.content;

      // 加载 vivo 短剧
      this.vshortplays = null;
      res = await this.$api.apiCommonVshortplays();
      this.vshortplays = res.content;
    },

    // 取消
    async onCancel() {
      // 页面回退
      this.$router.go(-1); 
    },
  },
};
</script>

<style lang='scss' scoped>
.box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex-wrap: nowrap;
  align-items: center;
  overflow: auto;
}
.path {
  margin: 10px 5px 0px 15px;
  padding: 0px;
  width: 100%;
  height: 20px;
  color: rgb(6, 6, 31);
  font-size: 1rem;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: center;
}
.path_img {
  margin-right: 5px;
  height: 15px;
  width: 15px;
}
.path_txt {
  width: 100%;
  height: 20px;
  text-align: left;
}
.work {
  margin: 10px 5px 10px 5px;
  padding: 10px 0px 20px 0px;
  width: 98%;
  height: calc(100% - 20px);
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex-wrap: wrap;
  background: #fff;
  border-radius: 9px;
  align-items: center;
}
.work_form {
  width: 100%;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.el-form-item {
  margin: 20px 5px 0px 15px;
  width: 96%;
  min-height: 38px;
  height: auto;
}
.el-input {
  width: 300px;
}
.el-select {
  width: 300px;
}
.el-button {
  width: 100px;
}
</style>